var render, staticRenderFns
import script from "./Sponsors.vue?vue&type=script&lang=js&"
export * from "./Sponsors.vue?vue&type=script&lang=js&"
import style0 from "./Sponsors.vue?vue&type=style&index=0&id=d4f950f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f950f2",
  null
  
)

/* custom blocks */
import block0 from "./Sponsors.vue?vue&type=custom&index=0&blockType=a&href=https%3A%2F%2Fwww.dosign.com%2Fnl-nl%2Fcarriere%2Fdosign-students%2F%3Futm_source%3DSV%26utm_medium%3Dlink%26utm_campaign%3DPunch%2B_Students_paid&target=_blank"
if (typeof block0 === 'function') block0(component)

export default component.exports